<template>
  <div class="thomse">
    <img style="width: 100%;" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/indexBg.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<style scoped>
.thomse{
  width: 100%;
}
</style>
